/**
 * A lookup that is switched off answers "<Service> is switched off (LOOKUP_X_ENABLED is off); nothing
 * was sent." The parenthesis names the deployment switch, which is for whoever runs the platform and is
 * recorded in the outside-services register, not for the person reading a deal. The sentence stands
 * without it. Everything else is returned exactly as received.
 */
const SWITCH_NOTE = /\s*\([A-Z][A-Z0-9_]{3,} is off\)/g

export function plainRefusal(text: string): string
export function plainRefusal(text: string | null | undefined): string | null
export function plainRefusal(text: string | null | undefined): string | null {
  if (text == null) return null
  return text.replace(SWITCH_NOTE, '')
}
